import { useEffect } from "react"
import { gsap } from "gsap";
import loaderImg from "assets/images/logos/logo.png";
import f3 from "assets/images/factions/f3.png";
import f4 from "assets/images/factions/f4.png";

// ==== web loader
const WebLoader = () => {
    useEffect(() => {
        // header animation
        let tlmHeader = gsap.timeline({ paused: true });
        // 
        tlmHeader.to(".hero_content", {
            opacity: 1,
            y: 0,
            duration: .8,
            delay: .05,
            ease: 'easeIn',
        },
            ""
        )

        // end the loader last step
        const endLoader = () => {
            let el = document.getElementById("webLoader");
            el.classList.add("finished-full-loader");
            document.body.classList.remove("stop-scroll");
            // play header animation
            tlmHeader.play();
        };

        // play the loader
        const gsapLoadingAnimation = () => {
            // set initial
            let el = document.getElementById("webLoader");
            el.classList.remove("finished-full-loader");
            // 
            gsap.set(".loader-image", { 
                x: "-50%",
                y: "-50%",
                top: "38%", 
            });
            gsap.set(".loader-logo-wrapper", {
                x: "-50%",
                y: "200%",
                bottom: "-4%"
            })
            gsap.set(".loader-logo-middle", { width: "0" })
            gsap.set(".hero_content", { opacity: "0", y: "150px" });
            // loader animation defined here
            let tlm = gsap.timeline({ repeat: 0, paused: true });
            tlm.fromTo('.loader-logo-wrapper',
                {
                    x: "-50%",
                    y: "200%",
                    bottom: "-4%"
                },
                {
                    x: "-50%",
                    y: 0,
                    bottom: "7%",
                    ease: 'linear',
                    duration: 0.4
                },
            )
                .fromTo('.loader-logo-middle',
                    {
                        width: 0,
                    },
                    {
                        ease: 'linear',
                        width: "auto",
                        duration: .7
                    },
                    "+=.8"
                )
                .to('.loader-logo-wrapper',
                    {
                        bottom: "47%",
                        duration: 0.4
                    },
                    "+=1.1"
                )
                .to('.loader-logo-wrapper',
                    {
                        scale: "1.2"
                    },
                    "<"
                )
                .to('.loader-image',
                    {
                        top: "55%"
                    },
                    "<"
                )
                .to('.loader-image',
                    {
                        opacity: 0,
                    },
                    "<"
                )
                .to('.loader-logo-middle',
                    {
                        width: 0,
                    },
                    "+=.2"
                )
                .to('.web-loader',
                    {
                        height: "0",
                        overflow: "hidden",
                        duration: .4
                    },
                    "+=.1"
                )
                .to('.loader-logo-wrapper',
                    {
                        opacity: 0,
                        duration: .4,
                        onComplete: () => endLoader(),
                    },
                    "<"
                )
            tlm.play();
        }
        // 
        gsapLoadingAnimation()
        return () => {
            gsapLoadingAnimation()
        }
    }, []);
    return (
        <div id="webLoader" className="web-loader">
            <img
                className="loader-image"
                src={loaderImg}
                alt="SpaceWarrios"
                width="490"
                height=""
            />
            <div className="loader-logo-wrapper d_flex justify-content-center align-items-center">
                <div className="loader-logo d_flex align-items-center justify-content-center">
                    <img width="50" src={f3} alt="" />
                </div>
                <div className="loader-logo-middle d_flex align-items-center justify-content-center">
                    <h3 className="font_spaced">
                        Loading..
                    </h3>
                </div>
                <div className="loader-logo d_flex align-items-center justify-content-center loader-logo-right">
                    <img width="50" src={f4} alt="" />
                </div>
            </div>
        </div>
    )
};

export default WebLoader